// ----------------------------------------------------------------------
export var PlayerType;
(function (PlayerType) {
    PlayerType[PlayerType["audio"] = 0] = "audio";
    PlayerType[PlayerType["video"] = 1] = "video";
})(PlayerType || (PlayerType = {}));
// ----------------------------------------------------------------------
export var PlayerControls;
(function (PlayerControls) {
    PlayerControls[PlayerControls["captions"] = 0] = "captions";
    PlayerControls[PlayerControls["chapters"] = 1] = "chapters";
    PlayerControls[PlayerControls["duration"] = 2] = "duration";
    PlayerControls[PlayerControls["fullscreen"] = 3] = "fullscreen";
    PlayerControls[PlayerControls["play"] = 4] = "play";
    PlayerControls[PlayerControls["progressBar"] = 5] = "progressBar";
    PlayerControls[PlayerControls["volume"] = 6] = "volume";
})(PlayerControls || (PlayerControls = {}));
